/**
 * @param id: 题目唯一标识
 * @param title: 题目
 * @param desc: 题目描述
 * @param type: btnAdd\datePicker\drag\drawer\doubleInputText\inputNumber\inputText\mulitpleModal\radio\textarea\radioInput
 * @param next：下一道题的id
 * @param {Array} answers：在type为radio \ mulitpleModal \ drag 的答案
 * @param {string} answers.id : 答案唯一标识
 * @param {string} answers.answertitle: 答案标题
 * @param {string} answers.next: 下一道题的id
 * @param {string} answers.desc: 描述
 */
const questionsList = [
  // 1 -> 101
  {
    id: '1',
    title: 'Quels sont vos objectifs ?',
    type: 'drag',
    desc: 'Classez-les par ordre de priorité',
    answers: [
      {
        id: '1-1',
        answertitle: 'Préparer ma retraite',
        icon: 'drag1',
      },
      {
        id: '1-2',
        answertitle: 'Améliorer les rendements de mon épargne',
        icon: 'drag2',
      },
      {
        id: '1-3',
        answertitle: 'Créer de la richesse sur le long-terme',
        icon: 'drag3',
      },
      {
        id: '1-4',
        answertitle: 'Protéger mes économies contre l’inflation',
        icon: 'drag4',
      },
      {
        id: '1-5',
        answertitle: 'Économiser de l’argent pour un futur projet',
        icon: 'drag5',
      },
    ],
    next: '2',
  },
  // 2 -> 100
  {
    id: '2',
    title:
      'Souhaitez-vous que tous vos investissements répondent aux critères ESG* ? ',
    desc:
      'En sélectionnant “Oui”, nous exclurons certains types d’investissements.',
    type: 'radio',
    example: {
      title: '*Environnement, Social et Gouvernance',
      desc:
        "Elle évalue une entreprise au-delà des critères financiers habituels, en prenant en compte différents aspects de sa gestion et de son impact, essentiels pour les stratégies d'investissement responsable.",
    },
    answers: [
      {
        id: '2-1',
        answertitle: 'Oui',
        next: '3',
      },
      {
        id: '2-2',
        answertitle: 'Non',
        next: '3',
      },
    ],
  },
  // 3 -> 1
  {
    id: '3',
    title: 'Quel âge avez-vous ?',
    type: 'inputNumber',
    min: 1,
    compareValueWarning: {
      min: 18,
      max: 80,
      warningDesc:
        'Oops, pour des raisons réglementaires nous ne pouvons pas conseiller des gens de votre âge',
    },
    next: '4',
    inputType: 'positiveInteger',
  },
  // 4 -> 2
  {
    id: '4',
    subTitle: 'Plusieurs options possibles',
    title:
      'Quels sont les placements que vous possédez déjà parmi ceux proposés ci-dessous :',
    type: 'multipleModal',
    example: {
      title:
        'Dois-je donner un nombre précis pour les montants de chacun de mes placements ?',
      desc:
        'Non, une estimation est suffisante ! Cependant, si vous inscrivez les chiffres exacts, c’est encore mieux !',
    },
    next: '7',
    answers: [
      {
        id: '4-1',
        answertitle: 'Livret A',
        children: {
          id: '4-1-1',
          type: 'inputText',
        },
      },
      {
        id: '4-2',
        answertitle: 'LDDS',
        children: {
          id: '4-1-2',
          type: 'inputText',
        },
      },
      {
        id: '4-3',
        answertitle: 'LEP',
        children: {
          id: '4-1-3',
          type: 'inputText',
        },
      },
      {
        id: '4-4',
        answertitle: 'PEL',
        children: {
          id: '4-1-4',
          type: 'inputText',
        },
      },
      {
        id: '4-5',
        answertitle: 'Compte courant',
        children: {
          id: '4-1-5',
          type: 'inputText',
        },
      },
      {
        id: '4-6',
        answertitle: 'Assurance vie',
        next: ['5', '6', '40', '41'],
      },
      {
        id: '4-7',
        answertitle: 'PER',
        next: ['5', '6', '40', '41'],
      },
      {
        id: '4-8',
        answertitle: 'PEE',
        next: ['5', '6', '40', '41'],
      },
      {
        id: '4-9',
        answertitle: 'PEA',
        next: ['5', '6', '40', '41'],
      },
      {
        id: '4-10',
        answertitle: 'CTO',
        next: ['5', '6', '40', '41'],
      },
    ],
  },
  // 5 -> 103
  {
    id: '5',
    type: 'drawer',
    isSubQuestion: true,
    title: 'Combien avez-vous actuellement sur votre',
    next: '6',
    placeholder: 'Entrer...',
    example: {
      title:
        'Dois-je donner un nombre précis pour les montants de chacun de mes placements ?',
      desc:
        'Non, une estimation est suffisante ! Cependant, si vous inscrivez les chiffres exacts, c’est encore mieux !',
    },
  },
  // 6 -> 3
  {
    id: '6',
    type: 'drawer',
    isSubQuestion: true,
    title: 'Avez-vous délégué la gestion de votre contrat ? (gestion pilotée)',
    desc: 'Répondez “Non” si vous ne savez pas',
    example: {
      title: 'Qu’est-ce que la gestion pilotée ?',
      desc:
        'Votre banque choisit pour vous les produits financiers dans lesquels vous investissez votre argent.',
    },
    answers: [
      {
        id: '6-1',
        answertitle: 'Oui',
        next: '41',
      },
      {
        id: '6-2',
        answertitle: 'Non',
        next: '41',
      },
    ],
  },
  // 40 -> 4
  {
    id: '40',
    type: 'drawer',
    isSubQuestion: true,
    title: 'Pouvez-nous donner les gains (ou pertes) totaux de votre ',
    desc:
      'Répondez “Non” si vous ne trouvez pas les gains et pertes de votre contrat',
    next: '41',
    example: {
      title: 'Où trouver les gains ou pertes de mon contrat ?',
      desc: `
      <div>
      Calcul des gains et pertes = Valorisation actuelle - Total investi depuis l’origine 
      </div>
      <div>
      Exemple : j’ai une assurance-vie dont la valorisation est de 20 000€. J’ai investi 15 000€.
      <div>
      Calcul de mes gains = 20 000 - 15 000 = 5 000€.
      </div>
      <div>
      => J’ai donc un gain de 5 000€.
      </div>
      `,
    },
    answers: [
      {
        id: '40-1',
        answertitle: 'Oui',
        showCloseDrewerId: '41',
        children: {
          parentId: '40-1',
          id: '40-1-1',
          type: 'inputText',
        },
      },
      {
        id: '40-2',
        answertitle: 'Non',
        isCloseDrewer: true,
      },
    ],
  },
  // 41 -> 5
  {
    id: '41',
    type: 'drawer',
    isSubQuestion: true,
    title: 'En quelle année avez-vous ouvert votre ',
    next: '7',
  },
  // 7 -> 99
  {
    id: '7',
    title:
      "Avez-vous un autre montant à investir qui n'a pas été mentionné dans les questions précédentes ?",
    type: 'radioInput',
    precision: 0,
    min: 1,
    desc:
      'Cela peut être une donation, un héritage, un autre placement (crowdfunding immobilier, ...)',
    answers: [
      {
        id: '7-1',
        answertitle: 'Oui',
        children: {
          id: '7-1-1',
          type: 'inputNumber',
          pleaseholder: 'Entrer le pourcentage ...',
        },
        next: '8',
      },
      {
        id: '7-2',
        answertitle: 'Non',
        next: '8',
      },
    ],
  },
  // 8 -> 102
  {
    id: '8',
    title: 'Avez-vous déjà fait un investissement immobilier locatif ?',
    type: 'radio',
    desc:
      'Investissement immobilier locatif : achat d’un bien immobilier pour le louer.',
    example: {
      title: 'Le saviez-vous ?',
      desc: `Il existe différentes manières d’investir dans l’immobilier comme les SCPI, le crowdfunding immobilier ou encore l’immobilier fractionné.`,
    },
    answers: [
      {
        id: '8-1',
        answertitle: 'Oui',
        next: '10',
      },
      {
        id: '8-2',
        answertitle: 'Non',
        next: '10',
      },
    ],
  },
  // 10 -> 7
  {
    id: '10',
    title: 'Avez-vous des emprunts en cours ?',
    type: 'radio',
    answers: [
      {
        id: '10-1',
        answertitle: 'Oui',
        next: '11',
      },
      {
        id: '10-2',
        answertitle: 'Non',
        next: '12',
      },
    ],
  },
  // 11 -> 8
  {
    id: '11',
    title: 'Merci de nous fournir les détails de vos prêts en cours :',
    desc: 'Cliquez sur le bouton pour ajouter un prêt',
    type: 'btnAdd',
    next: '12',
    example: {
      title: "Assurons-nous d'être sur la même longueur d'onde !",
      desc: `<div>Mensualité = montant que vous remboursez chaque mois</div>
      <div>
        Durée totale du prêt = nombre d’années pour laquelle vous avez contracté un prêt (20, 25 ans ...)
      </div>
      `,
    },
  },
  // 12 -> 9
  {
    id: '12',
    title: 'Possédez-vous votre résidence principale ?',
    type: 'radio',
    answers: [
      {
        id: '12-1',
        answertitle: 'Oui',
        next: '13',
      },
      {
        id: '12-2',
        answertitle: 'Non',
        next: '13',
      },
    ],
  },
  // 13 -> 11
  {
    id: '13',
    title:
      'Quel est votre salaire mensuel actuel avant impôts et après impôts ?',
    desc: '(le montant en bas de votre fiche de paie)',
    type: 'doubleInputText',
    next: '14',
    example: {
      title: 'Quelle est la différence ?',
      desc: `Salaire avant prélèvement à la source = montant disponible sur la fiche de paie avant impôts
        <p>
        Salaire après prélèvement à la source = montant reçu sur le compte bancaire
        </p>
        `,
    },
  },
  // 14 -> 12
  {
    id: '14',
    title:
      'Recevez-vous un bonus avant impôts ? Si oui, quel en est le montant ?',
    desc: `Si vous n'en avez pas, indiquez 0`,
    type: 'inputNumber',
    next: '15',
    min: 0,
    placeholder: 'Entrer...',
  },
  // 15 -> 13
  {
    id: '15',
    title: 'Combien dépensez-vous chaque mois en moyenne ?',
    desc: 'Montant sans inclure le loyer.',
    example: {
      title: 'C’est une estimation bien sûr :)',
      desc: `Que vous soyez plutôt cigale ou fourmi, connaître vos dépenses mensuelles approximatives est un excellent indicateur à suivre !`,
    },
    type: 'inputNumber',
    compareValueWarning: {
      compareId: '13',
      compareKey: 'deductiveSalary',
      warningDesc:
        "Vos dépenses dépassent votre salaire. Êtes-vous certain du montant que vous venez d'entrer ?",
    },
    next: '16',
    min: 0,
    placeholder: 'Entrer...',
  },
  // 16 -> 14
  {
    id: '16',
    title: 'Combien arrivez-vous à mettre de côté chaque mois en moyenne ?',
    type: 'inputNumber',
    // desc: '(compte courant compris)',
    compareValueWarning: {
      min: 100,
      warningDesc: `Investir moins de 100 €/mois ne vous permettra pas de construire un patrimoine solide. Pour poursuivre le diagnostic, saisissez un montant d’au moins 100 € et visualisez comment votre patrimoine évoluerait en mettant cette somme de côté chaque mois !`,
    },
    min: 1,
    placeholder: 'Entrer...',
    next: [
      {
        parentAnswerId: '12-1',
        parentQuestionId: '12',
        next: '17',
      },
      {
        parentAnswerId: '12-2',
        parentQuestionId: '12',
        next: '27',
      },
    ],
  },
  // 17 -> 15
  {
    id: '17',
    title: 'Êtes-vous marié·e ou pacsé·e ?',
    type: 'radio',
    answers: [
      {
        id: '17-1',
        answertitle: 'Oui',
        next: '18',
      },
      {
        id: '17-2',
        answertitle: 'Non',
        next: '19',
      },
    ],
  },
  // 18 -> 16
  {
    id: '18',
    title:
      'Quel est le salaire mensuel de votre conjoint (une estimation est suffisante) ?',
    desc: 'Si vous ne savez pas exactement, donnez une estimation',
    type: 'inputNumber',
    next: '19',
    min: 0,
    placeholder: 'Entrer...',
  },
  // 19 -> 17
  {
    id: '19',
    title: 'Avez-vous des enfants ?',
    type: 'radio',
    answers: [
      {
        id: '19-1',
        answertitle: 'Oui',
        next: '20',
      },
      {
        id: '19-2',
        answertitle: 'Non',
        next: '22',
      },
    ],
  },
  // 20 -> 18
  {
    id: '20',
    title: 'Combien d’enfants avez-vous ?',
    type: 'inputNumber',
    min: 1,
    inputType: 'positiveInteger', // inputNumber为正整数
    next: [
      {
        parentAnswerId: '12-1',
        parentQuestionId: '12',
        next: '21',
      },
      {
        parentAnswerId: '12-2',
        parentQuestionId: '12',
        next: '28',
      },
    ],
  },
  // 21 -> 19-2
  {
    id: '21',
    title: 'Préférez-vous éviter de souscrire un prêt bancaire ?',
    type: 'radio',
    answers: [
      {
        id: '21-1',
        answertitle: 'Oui',
        next: '99',
        classifiList: [
          {
            value: 'IF',
            mark: 'P1',
            questionAnswerId: [
              {
                parentQuestionId: '12',
                parentAnswerId: '12-1',
              },
            ],
          },
          {
            value: 'IF',
            mark: 'P7',
            questionAnswerId: [
              {
                parentQuestionId: '12',
                parentAnswerId: '12-2',
              },
            ],
          },
        ],
      },
      {
        id: '21-2',
        answertitle: 'Non',
        next: '24',
      },
    ],
  },
  // 22 -> 19
  {
    id: '22',
    title: 'Souhaitez-vous avoir des enfants ?',
    type: 'radio',
    desc: 'Si vous ne savez pas, répondez non',
    answers: [
      {
        id: '22-1',
        answertitle: 'Oui',
        next: '23',
      },
      {
        id: '22-2',
        answertitle: 'Non',
        // next: '21',
        next: [
          {
            parentAnswerId: '12-1',
            parentQuestionId: '12',
            next: '21',
          },
          {
            parentAnswerId: '12-2',
            parentQuestionId: '12',
            next: '28',
          },
        ],
      },
    ],
  },
  // 23 -> 19-1
  {
    id: '23',
    title: 'Combien d’enfants souhaiteriez-vous ?',
    type: 'inputNumber',
    inputType: 'positiveInteger', // inputNumber为正整数
    min: 1,
    next: [
      {
        parentAnswerId: '12-1',
        parentQuestionId: '12',
        next: '21',
      },
      {
        parentAnswerId: '12-2',
        parentQuestionId: '12',
        next: '28',
      },
    ],
  },
  // 24 -> 20
  {
    id: '24',
    type: 'radio',
    title:
      'Combien de temps êtes-vous prêt·e à consacrer à vos futurs investissements ?',
    answers: [
      {
        id: '24-1',
        answertitle: 'Très peu de temps (< 2 heures/mois)',
        next: '99',
        classifiList: [
          {
            value: 'IF',
            mark: 'P2',
            questionAnswerId: [
              {
                parentQuestionId: '12',
                parentAnswerId: '12-1',
              },
            ],
          },
          {
            value: 'IF',
            mark: 'P8',
            questionAnswerId: [
              {
                parentQuestionId: '12',
                parentAnswerId: '12-2',
              },
              {
                parentQuestionId: '28',
                parentAnswerId: '28-2',
              },
            ],
          },
          {
            value: 'IF',
            mark: 'P17',
            questionAnswerId: [
              {
                parentQuestionId: '12',
                parentAnswerId: '12-2',
              },
              {
                parentQuestionId: '28',
                parentAnswerId: '28-3',
              },
            ],
          },
        ],
      },
      {
        id: '24-2',
        answertitle: 'Un peu de temps (2 <> 4 heures/mois)',
        next: '99',
        classifiList: [
          {
            isVerifyCalculateStatus: true,
            questionAnswerId: [
              {
                parentQuestionId: '12',
                parentAnswerId: '12-1',
              },
            ],
            calculationStatusList: [
              {
                status: 1, // he does't have enough
                value: 'IF',
                mark: 'P3',
              },
              {
                status: 2, // he does't have loan
                value: 'IF',
                mark: 'P4',
              },
              {
                status: 3, // he does't have loan
                value: 'IL+IF',
                mark: 'P5',
              },
            ],
          },
          {
            isVerifyCalculateStatus: true,
            questionAnswerId: [
              {
                parentQuestionId: '12',
                parentAnswerId: '12-2',
              },
              {
                parentQuestionId: '28',
                parentAnswerId: '28-2',
              },
            ],
            calculationStatusList: [
              {
                status: 1, // he does't have enough
                value: 'IF',
                mark: 'P9',
              },
              {
                status: 2, // he does't have loan
                value: 'IF',
                mark: 'P10',
              },
              {
                status: 3, // he does't have loan
                value: 'IL+IF',
                mark: 'P11',
              },
            ],
          },
          {
            isVerifyCalculateStatus: true,
            questionAnswerId: [
              {
                parentQuestionId: '12',
                parentAnswerId: '12-2',
              },
              {
                parentQuestionId: '28',
                parentAnswerId: '28-3',
              },
            ],
            calculationStatusList: [
              {
                status: 1, // he does't have enough
                value: 'IF',
                mark: 'P18',
              },
              {
                status: 2, // he does't have loan
                value: 'IF',
                mark: 'P19',
              },
              {
                status: 3, // he does't have loan
                value: 'IL+IF',
                mark: 'P20',
              },
            ],
          },
        ],
        calculation: {
          banlanceList: [
            {
              key: 'x',
              parentAnswerId: '4',
              calcutaleAnswerList: [
                { id: '4-1' },
                { id: '4-2' },
                { id: '4-3' },
                { id: '4-4' },
                { id: '4-5' },
                { id: '4-6', childrenAanswerIdx: '0' },
              ],
            },
            {
              key: 'y',
              parentAnswerId: '15',
              calcutaleAnswerList: [{ id: '15' }],
            },
          ],
        },
      },
      {
        id: '24-3',
        answertitle: 'Un temps conséquent (> 4 heures/mois)',
        next: '99',
        classifiList: [
          {
            isVerifyCalculateStatus: true, // 需要校验计算结果中的status
            questionAnswerId: [
              {
                parentQuestionId: '12',
                parentAnswerId: '12-1',
              },
            ],
            calculationStatusList: [
              {
                status: 1, // he does't have enough
                value: 'IF',
                mark: 'P3',
              },
              {
                status: 2, // he does't have loan
                value: 'IF',
                mark: 'P4',
              },
              {
                status: 3, // he does't have loan
                value: 'IL+IF',
                mark: 'P5',
              },
            ],
          },
          {
            isVerifyCalculateStatus: true,
            questionAnswerId: [
              {
                parentQuestionId: '12',
                parentAnswerId: '12-2',
              },
              {
                parentQuestionId: '28',
                parentAnswerId: '28-2',
              },
            ],
            calculationStatusList: [
              {
                status: 1, // he does't have enough
                value: 'IF',
                mark: 'P9',
              },
              {
                status: 2, // he does't have loan
                value: 'IF',
                mark: 'P10',
              },
              {
                status: 3, // he does't have loan
                value: 'IL+IF',
                mark: 'P11',
              },
            ],
          },
          {
            isVerifyCalculateStatus: true,
            questionAnswerId: [
              {
                parentQuestionId: '12',
                parentAnswerId: '12-2',
              },
              {
                parentQuestionId: '28',
                parentAnswerId: '28-3',
              },
            ],
            calculationStatusList: [
              {
                status: 1, // he does't have enough
                value: 'IF',
                mark: 'P18',
              },
              {
                status: 2, // he does't have loan
                value: 'IF',
                mark: 'P19',
              },
              {
                status: 3, // he does't have loan
                value: 'IL+IF ',
                mark: 'P20',
              },
            ],
          },
        ],
        calculation: {
          banlanceList: [
            {
              key: 'x',
              parentAnswerId: '4',
              // calcutaleAnswerList: ['4-1', '4-2', '4-3', '4-4', '4-5', '4-6'],
              calcutaleAnswerList: [
                { id: '4-1' },
                { id: '4-2' },
                { id: '4-3' },
                { id: '4-4' },
                { id: '4-5' },
                { id: '4-6', childrenAanswerIdx: 0 },
              ],
            },
            {
              key: 'y',
              parentAnswerId: '15',
              calcutaleAnswerList: [{ id: '15' }],
            },
          ],
        },
      },
    ],
  },
  // 27 -> 28
  {
    id: '27',
    title: 'Quel est le montant de votre loyer ?',
    desc: "Si vous n'en avez pas, indiquez 0",
    type: 'inputNumber',
    next: '17',
    placeholder: 'Entrer...',
    min: 0,
    precision: 2,
  },
  // 28 -> 26
  {
    id: '28',
    title: 'La résidence principale pour vous, c’est ...',
    type: 'radio',
    answers: [
      {
        id: '28-1',
        answertitle:
          "Un objectif ! Je veux l'acquérir dès que possible et je suis certain de l'acheter un jour.",
        next: '29',
      },
      {
        id: '28-2',
        answertitle:
          "Je souhaite rester le plus flexible possible, ce n'est pas donc une priorité pour le moment.",
        next: '21',
      },
      {
        id: '28-3',
        answertitle:
          "J'hésite ! Je veux déterminer quel choix est le plus avantageux financièrement pour moi.",
        next: '36',
      },
    ],
  },
  // 29 -> 48
  {
    id: '29',
    title:
      'Vos proches pourraient-il vous aider financièrement dans ce projet ?',
    type: 'radio',
    answers: [
      {
        id: '29-1',
        answertitle: 'Oui',
        next: '30',
      },
      {
        id: '29-2',
        answertitle: 'Non',
        next: '31',
      },
    ],
  },
  // 30 -> 48-1
  {
    id: '30',
    title: 'Quel serait le montant reçu (environ) ?',
    type: 'inputNumber',
    next: '21',
    placeholder: 'Entrer...',
    classifiList: [
      {
        value: 'AttenteRP',
        mark: 'P6',
        // isCurrentQuestion: true, // 当前题目无序查找questionAnswerId
        questionAnswerId: [
          {
            parentQuestionId: '30',
          },
        ],
        // next: '31',
      },
    ],
  },
  // 31 -> 27
  {
    id: '31',
    title: 'Quel serait le montant global du projet ?',
    type: 'inputNumber',
    example: {
      title: 'Que signifie "montant global du projet" ?',
      desc:
        'Cela signifie le coût total de votre projet immobilier, frais de notaires inclus. En d\'autres termes, c\'est la somme maximale que vous souhaitez débourser.',
    },
    placeholder: 'Entrer...',
    next: '21',
    classifiList: [
      {
        value: 'AttenteRP',
        mark: 'P6',
        // isCurrentQuestion: true, // 当前题目无序查找questionAnswerId
        questionAnswerId: [
          {
            parentQuestionId: '31',
          },
        ],
        // next: '31',
      },
    ],
  },
  // 36 -> 31
  {
    id: '36',
    title:
      'Combien de temps pensez-vous pouvoir rester dans ce logement ? (une estimation)',
    type: 'radio',
    // next: '37',
    // compareValue: 10, // 此题需要对比value进行判断下一题走向
    answers: [
      {
        id: '36-1',
        answertitle: '< 10 ans',
        next: '24',
      },
      {
        id: '36-2',
        answertitle: '> 10 ans',
        next: '38',
      },
    ],
    // next: [
    //   {
    //     parentAnswerId: '36',
    //     parentQuestionId: '36',
    //     valueKey: 'smaller',
    //     next: '24',
    //   },
    //   {
    //     parentAnswerId: '36',
    //     parentQuestionId: '36',
    //     valueKey: 'bigger',
    //     next: '38',
    //   },
    // ],
  },
  // 38 -> 32
  {
    id: '38',
    title: 'Êtes-vous plutôt épargnant·e (fourmi) ou dépensier·ère (cigale) ?',
    type: 'radio',
    answers: [
      {
        id: '38-1',
        answertitle: 'Une fourmi',
        next: '39',
      },
      {
        id: '38-2',
        answertitle: 'Une cigale',
        next: '39',
      },
    ],
  },
  // 39 -> 33
  {
    id: '39',
    title: 'Préférez-vous vivre dans une grande ville ou une petite ville ?',
    desc:
      'Paris, Lyon, Bordeaux, Marseille sont des exemples de “grandes” villes',
    type: 'radio',
    answers: [
      {
        id: '39-1',
        answertitle: '“Petite” ville',
        next: [
          {
            parentQuestionId: '38',
            parentAnswerId: '38-1',
            next: '24',
          },
          {
            parentQuestionId: '38',
            parentAnswerId: '38-2',
            next: '99',
            classifiList: [
              {
                value: 'AttenteRP',
                mark: 'P27',
                questionAnswerId: [
                  {
                    parentQuestionId: '38',
                    parentAnswerId: '38-2',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: '39-2',
        answertitle: '“Grande” ville',
        next: [
          {
            parentQuestionId: '38',
            parentAnswerId: '38-1',
            next: '24',
          },
          {
            parentQuestionId: '38',
            parentAnswerId: '38-2',
            next: '99',
            classifiList: [
              {
                value: 'AttenteRP',
                mark: 'P28',
                questionAnswerId: [
                  {
                    parentQuestionId: '38',
                    parentAnswerId: '38-2',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  // 99 -> Fin (Question finale optionnelle sur situation personnelle)
  {
    id: '99',
    title: 'Précisez votre situation (optionnel)',
    desc: 'Si vous le souhaitez, précisez votre situation, vos objectifs de vie (professionnels et personnels) ainsi que tout investissement non mentionné, afin que nous personnalisions au maximum votre stratégie.',
    type: 'textarea',
    placeholder: 'Décrivez votre situation, vos objectifs...',
    required: false,
    isEnd: true,
  },
];
/**
 * @description:
 * @param type:btnAdd\datePicker\drag\drawer\doubleInputText\inputNumber\inputText\mulitpleModal\radio\textarea
 * @param value：1：字符串，2：数组，3：数组对象, 4: 数字, 5: 对象
 */
const valueType = new Map([
  ['inputNumber', '1'],
  ['radio', '5'],
  ['drag', '2'],
  ['datePicker', '1'],
  ['btnAdd', '3'],
  ['drawer', '3'],
  ['doubleInputText', '5'],
  ['inputText', '1'],
  ['multipleModal', '3'],
  ['textarea', '1'],
  ['radioInput', '5'],
]);

const questionEndData = {
  content: `<div>Félicitations, vous avez complété la première étape de votre diagnostic 💪</div>
      <div>Pour respecter la réglementation, nous devons maintenant évaluer vos connaissances financières, ce qui ne prendra pas plus de 2 minutes.</div>
      <div>Rassurez-vous, vos réponses ne sont pas bloquantes.</div>`,
  buttonLabel: 'Finir mon diagnostic personnalisé',
};

export { questionsList, valueType, questionEndData };
